import type { HTMLAttributes } from 'react';
import { cn } from '../utils';

function PageHeader({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('flex flex-col gap-4', className)} {...props} />;
}

export { PageHeader };
